<template>
  <section class="banner-sm-section">
    <b-modal
      id="book-counselling-modal-id"
      ref="book-counselling-modal-ref"
      centered
      title="Book Free Counselling"
      cancel-disabled
      ok-disabled
      :hide-footer="true"
    >
      <vue-calendly :height="600" url="https://calendly.com/info-aliff-39025">
      </vue-calendly>
    </b-modal>
    <div
      class="container-fluid bg-primary-gradient border-20 d-flex justify-content-center bg-primary-responsive"
    >
      <div class="col-lg-11">
        <div class="row align-items-center">
          <div class="col-xl-7 col-md-6 py-4 py-md-0">
            <div>
              <h1 class="text-center-responsive book-counselling pb-3">
                <!-- Studying abroad is much easier with Aliff. Just one call away
                  ! -->
                {{ text }}
              </h1>
              <div class="mt-4 d-flex align-items-center flex-wrap flex-fd-col">
                <button
                  v-b-modal.book-counselling-modal-id
                  class="btn btn-white-bg mr-md-3 mb-3 mb-lg-0 mr-2"
                >
                  Book free expert counselling 1
                </button>
                <!-- <button
                      @click="bookFreeCounselling"
                      class="btn btn-common-1 btn-secondary mr-md-3"
                    >
                      Book free expert counselling
                    </button> -->
                <a href="tel:+919987099890" class="anchor-text-white"
                  >Call us at +91 9987099890</a
                >
              </div>
            </div>
          </div>
          <div
            class="
              col-md-6 col-xl-2
              offset-xl-3
              px-0
              d-flex
              justify-content-end
            "
          >
            <div class="city-img d-flex justify-content-end pt-5">
              <img
                src="@/assets/imgs/city-illustration-light.png"
                class="d-none d-md-block"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { BModal } from "bootstrap-vue";
// import Calendly from "vue-calendly";
// import "https://assets.calendly.com/assets/external/widget.js"

export default {
  name: "BookFreeCounselling",
  components: {
    BModal
  },
  props: {
    text: {
      text: String,
      default: () => ""
    }
  },
  methods: {
    async bookFreeCounselling() {
      window.open("https://calendly.com/info-aliff-39025");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/partials/BookFreeCounselling.vue